var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-user-form',{attrs:{"add-user-function":"addDriver","link-back":"driver-list","new-title":"Nový řidič","title":"Řidič"}})}
var staticRenderFns = []

export { render, staticRenderFns }